'use client';

import { c as _c } from "react/compiler-runtime";
import NextError from 'next/error';
import { captureWithContext } from '@/lib/sentry-utils';
export default function GlobalError(t0) {
  const $ = _c(1);
  const {
    error
  } = t0;
  console.error("[GlobalError]", error);
  captureWithContext({
    error,
    context: "GlobalError",
    action: "render",
    metadata: {
      digest: error.digest
    }
  });
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <html lang="pt-BR"><body><NextError statusCode={0} /></body></html>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  return t1;
}